import PointsCard from './PointsCard';

export default PointsCard;
